import { nip19 } from "nostr-tools";
import { UserLink, type UserLinkProps } from "@/components/UserAvatar";
import { useCoordinatorServiceIdentity } from "@/hooks/useCoordinatorServiceIdentity";

type CICoordinatorLinkProps = Omit<UserLinkProps, "profilePath">;

/** Identity link whose primary destination is the CI coordinator profile. */
export function CICoordinatorLink({
  pubkey,
  ...props
}: CICoordinatorLinkProps) {
  const identity = useCoordinatorServiceIdentity(pubkey);
  return (
    <UserLink
      {...props}
      pubkey={pubkey}
      displayName={identity?.label}
      profilePath={`/coordinator/${nip19.npubEncode(pubkey)}`}
    />
  );
}
